import { SpaceTypeEnum } from 'src/common/external/bambi-api/bambiApi';

const spaceTypeBadgeLabelsMap: Record<SpaceTypeEnum, string> = {
  wheelchair: 'W',
  'wheelchair xl': 'W+',
  stretcher: 'S',
  ambulatory: 'A',
  'broda chair': 'BC',
  'geri chair': 'GC',
};

export function getSpaceTypeBadgeLabel(spaceType: SpaceTypeEnum) {
  return spaceTypeBadgeLabelsMap[spaceType];
}
